const PROFILE_HEADER = 'ProfileHeader';
const BOTTOM_SHEET_IFRAME = 'BottomSheetIframe';

export { PROFILE_HEADER, BOTTOM_SHEET_IFRAME };
